import {
    MEMBERS_PATH
} from '@/common/constants'

import { createStore } from 'vuex'
import axios from 'axios'
import SerializeQuery from '@/common/mixin/SerializeQuery'

const store = {
    state: {
        members: [],
        paginator: {
            limit: 10,
            count: 0,
            page: 1
        }
    },
    mutations: {
        SET_MEMBERS (state, value) {
            state.members = value
        },
        SET_PAGINATOR (state, value) {
            state.paginator = value
        },
        SET_PAGE (state, value) {
            state.paginator.page = value
        },
        CLEAR_MEMBER_SESSIONS (state, member_id) {
            const member = state.members.find(function (item) {
                return item.id === member_id
            })

            if (member) {
                member.sessions = []
            }
        },
        REMOVE_MEMBER_SESSION (state, data) {
            const member = state.members.find(function (item) {
                return item.id === data.member_id
            })

            if (member && Array.isArray(member.sessions)) {
                member.sessions = member.sessions.filter(session => session.id !== data.session_id)
            }
        }
    },
    actions: {
        async PAGINATE (context, data) {
            const qs = SerializeQuery.methods.serialize_query(data)
            let result
            try {
                result = await axios.get(`${MEMBERS_PATH}?${qs}`)
            } catch (error) {
                return error.response
            }

            context.commit('SET_MEMBERS', result.data.items)
            context.commit('SET_PAGINATOR', {
                limit: result.data.limit,
                count: result.data.count,
                page: result.data.page
            })
        },
        async GENERATE_PIN (context, data) {
            let response = {}
            try {
                response = await axios.put(`${MEMBERS_PATH}/${data.id}/pin`, data.params)
                context.dispatch('PAGINATE', {})
            } catch (error) {
                return error.response.data
            }
            return response.data
        },
        async CREATE (context, data) {
            let response = {}
            try {
                response = await axios.post(`${MEMBERS_PATH}`, data)
                context.dispatch('PAGINATE', {})
            } catch (error) {
                return error.response
            }
            return response
        },
        async UPDATE (context, data) {
            let response = {}
            try {
                response = await axios.put(`${MEMBERS_PATH}/${data.id}`, data.params)
                context.dispatch('PAGINATE', {})
            } catch (error) {
                return error.response
            }
            return response
        },
        async DELETE_MEMBER (context, data) {
            let response = {}
            try {
                response = await axios.delete(`${MEMBERS_PATH}/${data.member_id}`)
                context.dispatch('PAGINATE', {})
            } catch (error) {
                return error.response.data
            }
            return response.data
        },
        async DELETE_SESSION (context, data) {
            let response = {}
            try {
                response = await axios.delete(`${MEMBERS_PATH}/sessions/${data.member_id}/${data.session_id}`)
                context.commit('REMOVE_MEMBER_SESSION', data)
            } catch (error) {
                return error.response ? error.response.data : { status: 2 }
            }
            return response.data
        },
        async DELETE_ALL_SESSIONS (context, data) {
            let response = {}
            try {
                response = await axios.delete(`${MEMBERS_PATH}/sessions/${data.member_id}`)
                context.commit('CLEAR_MEMBER_SESSIONS', data.member_id)
            } catch (error) {
                return error.response ? error.response.data : { status: 2 }
            }
            return response.data
        }
    },
    strict: !import.meta.env.PROD
}

export default createStore(store)
